"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _core = require("@emotion/core");

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};

var Alert = function Alert(props, ref) {
  return (0, _core.jsx)("svg", (0, _extends2["default"])({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), (0, _core.jsx)("path", {
    fill: "currentColor",
    d: "M12.007 18.881a7.989 7.989 0 01-1.466-.155.808.808 0 00-.642.166 6.59 6.59 0 01-3.143 1.235.34.34 0 01-.318-.53c.44-.547.755-1.184.925-1.865a.504.504 0 00-.188-.49 6.612 6.612 0 01-2.668-5.236c0-3.792 3.357-6.875 7.5-6.875 4.142 0 7.5 3.083 7.5 6.876 0 3.792-3.358 6.874-7.5 6.874zm-.002-2.5a.937.937 0 100-1.874.937.937 0 000 1.874zm.624-8.75h-1.243a.316.316 0 00-.32.33l.287 5.312c.01.168.15.298.319.296h.671a.317.317 0 00.32-.296l.285-5.313a.316.316 0 00-.319-.329z"
  }));
};

var _default = (0, _react.forwardRef)(Alert);

var _default2 = _default;
exports["default"] = _default2;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"] : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Alert, "Alert", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Alert.tsx");
  reactHotLoader.register(_default, "default", "/builds/bA1zbJom/0/gojob/ui-bits/src/Icons/Alert.tsx");
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();